<template>
  <b-container fluid class="main" v-if="!loggedIn" style="padding:5vw;padding-top:20vh">


    <b-row align-h="center">
      <b-col cols="12" align-h='center' class="text-center">
        <h1>STUDIO EST</h1>
        <h2>Mot de passe</h2>
      </b-col>
      <b-col cols="10" align-h='center' class="text-center" style="padding:4vw;padding-bottom:0;height:18vh;">
        <b-form-input v-model="password" v-on:keyup.enter="login"
                      type="password" placeholder="password" class="text-center"
                      style="width:100%;height:100%;font-size:2.75em;color:black;" />
      </b-col>
      <b-col cols="9" align-h='center' class="text-center" style="padding-top:5vh;height:15vh">
        <b-button variant="light" style="width:100%" v-on:click="login()"><h3>Connect</h3></b-button>
      </b-col>
    </b-row>
  </b-container>

  <b-container fluid class="main" v-else style="padding:2vw;padding-top:2vh">
    <b-row v-if="processing" align-h='center' align-v='center' style="position:fixed;top:0;left:0;z-index:999;width:100vw;height:100vh;padding:0;margin:0;" >
      <b-col class="text-center" cols='12' style="background:black;width:100%;height:100%;padding:0;margin:0;opacity:.9;padding-top:30vh">
        <h1 style="color:lightgrey;padding:5vh;">en cours ...</h1>
      </b-col>
    </b-row>
    <b-row align-h="center" style="padding:1vh">
      <b-col cols="12" align-h='center' class="text-center"><h2>Entrée</h2></b-col>
      <b-col cols="3" align-h='center' class="text-center"><b-img style="object-fit:cover;padding:0;margin:0;" :src="main_photo" fluid-grow /></b-col>
      <b-col cols="2" align-h='center' class="text-left">
        <b-row align-h="left">
          <b-col cols="12" align-h='center' class="text-left" style="cursor:pointer">
            <label class="file-select">
              <b-button variant="light" style="width:100%;cursor:pointer" ><h3>Changer</h3></b-button>
              <input type="file"
                      name="main" style="position:absolute;width:100%;height:100%;top:0;left:0;opacity:0;z-index:99;cursor:pointer;"
                      accept="image/x-png,image/gif,image/jpeg" @change="upload" />
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row align-h="center" style="padding:2vh"><b-col cols="10" style="width:100%;height:1px;background:grey"></b-col></b-row>

    <b-row align-h="center" style="padding:2vh">
      <b-col cols="12" align-h='center' class="text-center"><h2>Gallerie</h2></b-col>
      <b-col v-for='(img,idx) in photos' cols="3" align-h='center' class="text-center">
        <b-row align-h="center"   style="padding:1vh">
          <b-col cols="12" align-h='center' class="text-left"><b-img style="object-fit:cover;padding:0;margin:0;" :src="img" fluid-grow /></b-col>
          <b-col cols="1" align-h='center' style='padding:0;margin:0;position:absolute;top:0;right:1vw' class="text-left">
            <b-button variant="danger"
                      style="width:50px;height:50px;padding:0;margin:0;opacity:1;font-size:2em;color:black;"
                      @click="delete_img('b',idx)">x</b-button>
          </b-col>
          <b-col cols="1" align-h='center' style='padding:0;margin:0;position:absolute;bottom:2vh;right:3vw' class="text-left">

            <b-button variant="light"
                      style="width:60px;height:60px;padding:0;margin:0;opacity:1;font-size:2.5em;color:black;"
                      @click="move_img_right(idx)">></b-button>
          </b-col>
          <b-col cols="1" align-h='center' style='padding:0;margin:0;position:absolute;bottom:2vh;left:3vw' class="text-left">

            <b-button variant="light"
                      style="width:60px;height:60px;padding:0;margin:0;opacity:1;font-size:2.5em;color:black;"
                      @click="move_img_left(idx)"><</b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" ></b-col>
      <b-col cols="8" align-h='center' class="text-center" style="cursor:pointer">
        <label class="file-select" style="width:100%">
          <b-button variant="light" style="width:100%;cursor:pointer" ><h3>Uploader</h3></b-button>
          <input type="file" multiple
                  name="gallery" style="position:absolute;width:100%;height:100%;top:0;left:0;opacity:0;z-index:99;cursor:pointer;"
                  accept="image/x-png,image/gif,image/jpeg" @change="upload" />
        </label>
      </b-col>

      <b-col cols="8" align-h='center' class="text-center" style="cursor:pointer;margin-top:3vh;">
        <b-button variant="dark" style="width:100%;cursor:pointer" @click="reorder" ><h3>Confirmer Arrangement</h3></b-button>
      </b-col>


    </b-row>

    <b-row align-h="center" style="padding:2vh"><b-col cols="10" style="width:100%;height:1px;background:grey"></b-col></b-row>

    <b-row align-h="center" style="padding:2vh">
      <b-col cols="12" align-h='center' class="text-center"><h2>Plans</h2></b-col>
      <b-col v-for='(img,idx) in plans_photos' cols="3" align-h='center' class="text-center">
        <b-row align-h="center"   style="padding:1vh">
          <b-col cols="12" align-h='center' class="text-left"><b-img style="object-fit:cover;padding:0;margin:0;" :src="img" fluid-grow /></b-col>
          <b-col cols="1" align-h='center' style='padding:0;margin:0;position:absolute;top:0;right:1vw' class="text-left">
            <b-button variant="danger"
                      style="width:50px;height:50px;padding:0;margin:0;opacity:1;font-size:2em;color:black;"
                      @click="delete_img('c',idx)">x</b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" ></b-col>
      <b-col cols="8" align-h='center' class="text-center" style="cursor:pointer">
        <label class="file-select" style="width:100%">
          <b-button variant="light" style="width:100%;cursor:pointer" ><h3>Uploader</h3></b-button>
          <input type="file" multiple
                  name="plans" style="position:absolute;width:100%;height:100%;top:0;left:0;opacity:0;z-index:99;cursor:pointer;"
                  accept="image/x-png,image/gif,image/jpeg" @change="upload" />
        </label>
      </b-col>
    </b-row>



    <b-row align-h="center" style="padding:2vh"><b-col cols="10" style="width:100%;height:1px;background:grey"></b-col></b-row>

    <b-row align-h="center" style="padding:2vh">
      <b-col cols="12" align-h='center' class="text-center"><h2>Textes</h2></b-col>
      <b-col v-for='(content,key,index) in contenu' cols="6" align-h='center' class="text-center">
        <b-row align-h="center"   style="padding:1vh" v-if="key != 'photos_order'">
          <b-col cols="12" ><h3>{{key.replace('_',' ')}}</h3></b-col>
          <b-col cols="12" >
            <textarea v-model="contenu[key]" style="width:100%;height:25vh;resize:both;overflow:auto;font-size:1.25em" ></textarea>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" ></b-col>
      <b-col cols="8" align-h='center' class="text-center" style="cursor:pointer">
          <b-button variant="light" style="width:100%;cursor:pointer" v-on:click="updateText()" ><h3>Mettre à jour</h3></b-button>
      </b-col>
    </b-row>


  </b-container>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Admin',
  components: {},
  methods: {
    login: function (){
      this.auth.signInWithEmailAndPassword('studioest@nza.com', this.password)
      .then(data => {
        console.log(data)
        this.loggedIn = true
        this.updateFromStorage()
      }).catch(err => { console.log(err.message) })
    },
    async updateFromStorage(){
      this.processing = false//true
      this.main_photo = '' ; this.photos = [] ; this.plans_photos = [] ; this.blobRefs={a:[],b:[],c:[],0:[],t:[]}
      const listRef = this.storage.ref('public').child('tVOnCGHNvtPmWeScGoAvS4p9Uyo1')
      const res = await listRef.listAll()
      for (let itemRef of res.items){
        console.log(itemRef.location.path_)
        this.blobRefs[ itemRef.location.path_.split('/').slice(-1)[0][0]  ].push(itemRef.location.path_)
        const url = await itemRef.getDownloadURL()
        if ( itemRef.location.path_.split('/').slice(-1)[0] == '0textcontenu.json' ) {
          /* contenu texte */
          const response = await axios.get(url)
          let data = {... JSON.parse(response.data)}
          const keys = Object.keys(data)
          for (let key of keys){
            if (key != 'photos_order') data[key] = data[key].replaceAll('<br/>','\n')
          }
          data.photos_order = JSON.parse(data.photos_order)
          this.contenu = data
          console.log(this.contenu.photos_order)
          //console.log(data.photos_order)
          //
        }
        else if ( itemRef.location.path_.split('/').slice(-1)[0][0] == 'a' ) {this.main_photo = url}
        else if ( itemRef.location.path_.split('/').slice(-1)[0][0] == 'b' ) {
          if (this.contenu.photos_order.includes(	itemRef.location.path_.split('/').slice(-1)[0]		)) this.photos.push(url)
					this.blobRefs.b.sort()
          this.photos_ref[itemRef.location.path_.split('/').slice(-1)[0]] = url
          //this.photos_order.push(itemRef.location.path_.split('/').slice(-1)[0])
        }
				else if ( itemRef.location.path_.split('/').slice(-1)[0][0] == 't' ) {console.log('nothing')}
        else {this.plans_photos.push(url) ; this.plans_photos.sort() ; this.blobRefs.c.sort() }
      }
      console.log(this.contenu.photos_order)
      console.log(this.photos_ref)
      let i = 0
			let photosrefthatexist = Object.keys(this.photos_ref)
			this.photos = Array.from(''.repeat(		photosrefthatexist.length)	)
			this.contenu.photos_order = this.contenu.photos_order.filter(e => photosrefthatexist.includes(e) )
			//console.log(this.photos)
      for (let p_ref of this.contenu.photos_order) {
        console.log(p_ref)
        this.photos[i] = (this.photos_ref[p_ref])
        i++
      }
      this.processing = false

    },
    async upload(e){
        console.log(e)
        if (e.target.files.length) {
          this.processing = true
          let i = 0;
          for (const file of e.target.files) {
            i++;
            this.processing_progress = [i,e.target.files.length]
            let blob_path = ''
            let fn = `b.${new Date().getTime()}.${file.name}`
            if (e.srcElement.name == 'main') blob_path = `public/tVOnCGHNvtPmWeScGoAvS4p9Uyo1/a.main`
            else if (e.srcElement.name == 'gallery') blob_path = `public/tVOnCGHNvtPmWeScGoAvS4p9Uyo1/${fn}`
            else blob_path =  `public/tVOnCGHNvtPmWeScGoAvS4p9Uyo1/c.${new Date().getTime()}.${file.name}`


            await this.storage.ref(blob_path).put(file)
            this.contenu.photos_order.push(fn)

          }
          this.processing = false
          //await this.updateFromStorage()
          await this.updateText()
        }
    },
    async reorder(){
      /*
      this.processing = true
      let i
      for (i = 0; i < this.photos.length; i++) { //this.photos.length
        this.processing_progress = [i,this.photos.length]
        const u = this.photos[i]
        const x = await axios({url: u,method: 'GET',responseType: 'blob'})
        await this.storage.ref(`public/tVOnCGHNvtPmWeScGoAvS4p9Uyo1/b.${i.toString().padStart(3, '0')}`).put(x.data)
        await this.storage.ref( this.blobRefs['b'][i]  ).delete()
      }
      this.processing = false
      await this.updateFromStorage()*/
      await this.updateText()
    },
    async updateText(){
      this.processing = true
      let to_upload = {...this.contenu}
      if (!('photos_order' in to_upload)) to_upload.photos_order=JSON.stringify([])
      to_upload.photos_order = JSON.stringify(this.contenu.photos_order) //JSON.stringify(Object.keys(this.photos_ref))
      // console.log(to_upload)
      let keys = Object.keys(to_upload)
      for (let key in to_upload ) {
        to_upload[key] = to_upload[key].replaceAll('\n','<br/>')
      }
      let contenuJSON = JSON.stringify(to_upload)

      // console.log(contenuJSON)
      const file = new Blob( [ JSON.stringify( contenuJSON, null, 2 ) ], { type: 'application/json', } );
      await this.storage.ref('public/tVOnCGHNvtPmWeScGoAvS4p9Uyo1/0textcontenu.json').put(file)
      this.processing = false
      await this.updateFromStorage()
    },
    async delete_img(where,idx){
      /*console.log(where,idx)
      console.log(this.contenu.photos_order[idx])
      console.log(this.blobRefs[where][idx])
      this.contenu.photos_order.splice(idx,1)
      this.photos.splice(idx,1)*/
      await this.storage.ref( this.blobRefs[where][idx]  ).delete()
      if (where == 'b') {
        this.contenu.photos_order.splice(idx,1)
        await this.updateText()
      }
      //await this.updateFromStorage()
    },
    move_img_left: async function(idx){
      let new_idx = idx-1
      if (new_idx>=0){
        const temp = this.photos[idx]
        this.photos[idx] = this.photos[new_idx]
        this.photos[new_idx] = temp
        this.photos.splice() // to force refresh on vue

        const temp2 = this.contenu.photos_order[idx]
        this.contenu.photos_order[idx] = this.contenu.photos_order[new_idx]
        this.contenu.photos_order[new_idx] = temp2
        //this.contenu.photos_order
      }
    },
    move_img_right: async function(idx){
      let new_idx = idx+1
      if (new_idx<this.photos.length){

        const temp = this.photos[idx]
        this.photos[idx] = this.photos[new_idx]
        this.photos[new_idx] = temp
        this.photos.splice() // to force refresh on vue

        const temp2 = this.contenu.photos_order[idx]
        this.contenu.photos_order[idx] = this.contenu.photos_order[new_idx]
        this.contenu.photos_order[new_idx] = temp2
      }
    },
  },
  mounted () {
    this.storage = this.$firebase.storage()
    this.auth = this.$firebase.auth()

  },
  data: function () {
    return {
      auth:null,
      storage:null,
      password:'',

      contenu:{},
      main_photo: '',
      photos: [],
      plans_photos: [],
      blobRefs: {},
      currentImgIdx:0,
      imgViewMode:false,
      loggedIn:false,
      processing:false,
      processing_progress:[0,0],

      photos_ref:{},

    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Kumbh+Sans:wght@300;400;700&display=swap');
html {
  scroll-behavior: smooth;
}
* {
  font-family: 'Kumbh Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  word-break: break-word;
  line-height:2em;
  scroll-behavior: smooth;

  transition: all 0.5s ease;
}
*::selection {
  background:pink;
}

a.link{
  font-size:1.3em;
  color:grey;
  text-decoration:none;
}
a.link:hover{
  color:black;
  text-decoration:none;
}
a.link:visited{
  text-decoration:none;
}

.navbar_normal{
  backgroud:none;padding-left:10vw;padding-right:10vw;
}
.toplogo{
  width:50px;
  height:50px;
  filter: brightness(0);
  transition-duration: 2s;
}
.toplogo:hover{filter: brightness(0.1);}
.navigation_title{
  color:black;
  font-size:.8em;
  text-align:left;
  transition-duration:0.1s;
}
a.navigation_title,a.navigation_title:hover,a.navigation_title:visited{  text-decoration:none; }
a.navigation_title:hover{color:#333;transition-duration:0.1s}

.navigation_btn{
  font-size:1.2em;
  color:black;
}
h1.title {
  font-size:3em;
  font-weight:bold;
  padding:2vh;
  margin-top:5vh;
}
h2.title {
  font-size:2em;
  padding:1vh;
  padding-left:0;
}
p {
  font-size:1.25em;
  letter-spacing:0.07em;
  color:black;
}
.main {
  background: #a4dde0;
  min-height:100vh;
}
.entry{
  padding:1vh;
  margin:1vh;
}
.gallery_img{
  object-fit: cover;padding:0;margin:0;
}
.gallery_img:hover{
  filter: brightness(0.5);
  cursor: pointer;
}


/*
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
*/
</style>
